export default __webpack_public_path__ + "5c306ac17668f8b755b5e47e2cf47301.svg";